import axios from 'axios';
import { SYMFONY_API_BASE_URL } from '@config/apiConfig';
const getUserSocialMediaAccounts = async (userHandle) => {
    return axios
        .get(`${SYMFONY_API_BASE_URL}/api/user/v1/${userHandle}/social_accounts`)
        .then((response) => response.data);
};
export default getUserSocialMediaAccounts;
